import { WHATS_APP_NOTIFICATION_REQUEST } from '@/store/actions/whatsAppNotifications';

const getters = {
  getNewWhatsAppNotificationCount: (state) => state.newWhatsAppNotificationCount,
};

const mutations = {
  [WHATS_APP_NOTIFICATION_REQUEST]: (state, { count }) => {
    state.newWhatsAppNotificationCount = count;
  },
};

const state = {
  newWhatsAppNotificationCount: 0,
};

export default () => ({
  getters,
  mutations,
  state,
});
